import { atom } from 'jotai'
export const tenantIdState = atom<string>(null as unknown as string)
